import {Row, Column, Container} from '../layoutComponents';
import {Overlay, Button, Paper, MenuBar, MenuText, H4} from '../styledComponents';
import React, { Component }  from 'react';


export class Modal extends Component{
  constructor(props){
    super(props);
    this.state={
      hidden: true
    }
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.error && nextProps.errorStatus=='requested'){
      this.showModal();
    }
  }
  showModal(){
    this.setState({hidden: false})
  }
  hideModal(){
    this.setState({hidden: true})
    this.props.onCloseError();
  }
  render(){
    return(
      <Overlay onClick={null} hidden={this.state.hidden} >
      <Column colWidth="100%" colJustify="center" colAlign="center">
      <Paper colWidth="90%" colMaxWidth="350px" paperPadding="0">
      <MenuBar connected>
        <MenuText>Error:</MenuText>
      </MenuBar>
        <Column space="20px" colAlign="center">
        <H4>{this.props.error}</H4>
        <Button onClick={this.hideModal}>Close</Button>
        </Column>
        </Paper>
        </Column>
      </Overlay>
    )
  }

}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/modal/modal.js